export const version = "3.2.0";
export const navbarBreakPoint = "xl"; // Vertical navbar breakpoint
export const topNavbarBreakpoint = "lg";
export default { version, navbarBreakPoint, topNavbarBreakpoint };
